import { useTranslation } from '@flecto/translations'
import { type CoreProduct } from '@flecto/types'

export type UseProductQuantityInfoOptions = {
  product?: CoreProduct
}

export type ProductQuantityInfo = {
  quantity: number | null
  quantityLabel: string | null
  isInfinity: boolean | null
  allowOverbooking: boolean | null
}

export function useProductQuantityInfo({
  product,
}: UseProductQuantityInfoOptions): ProductQuantityInfo {
  const quantityProps: ProductQuantityInfo = {
    quantity: null,
    quantityLabel: null,
    isInfinity: null,
    allowOverbooking: null,
  }

  const { t: tShared } = useTranslation('shared', { keyPrefix: 'shared' })

  if (!product) return quantityProps
  if (product.bundle && product.bundle_attributes?.bundle_items) {
    // @TODO: check the usage of this bundleItem, to take as example if need update also BundleItem model
    if (
      product?.quantity_available === null &&
      product?.track_quantity === false
    ) {
      quantityProps.quantity = null
      quantityProps.quantityLabel = tShared('new_bundle_items_unlimited')
      quantityProps.isInfinity = true
      quantityProps.allowOverbooking = null
      return quantityProps
    }

    const totalQuantity = product?.quantity_available ?? 0
    quantityProps.quantity = totalQuantity
    quantityProps.quantityLabel = totalQuantity.toString()
    quantityProps.isInfinity = false
    quantityProps.allowOverbooking = null
    return quantityProps
  }

  if (!product.bundle && product.item_attributes) {
    quantityProps.quantity = product.quantity ?? null
    quantityProps.quantityLabel = product.track_quantity
      ? (product.quantity?.toString() ?? '0')
      : tShared('new_bundle_items_unlimited')
    quantityProps.isInfinity = !product.track_quantity
    quantityProps.allowOverbooking = product.allow_overbooking ?? null
  }

  return quantityProps
}
